
import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { Row, Col, List, Typography, Table, Tag, Pagination, Button, Icon, Input } from 'antd';
import { PopUpForm } from '../../../lib/ui/popupform';
import ErrorWrapper from '../../../lib/error_wrapper';
import { NetworkDelaySearch, overrideHeaderTitle, overrideHeaderBack, showErrorInNotification, formatMoney } from '../../../lib/util';
import { BasicHeader } from '../../../components/basic_header';
import { setting_quick_menu } from '../../../util/ui_util';
import { TransparentButton } from '../../../components/basic_items';
import { Link } from 'react-router-dom';
const { Title } = Typography;

const queryString = require('query-string');

class TableList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      filter_query: {},
      selected_ids: []
    };

    this.list_tables = RESTExecutor.list().config({
      label: 'tables',
      params: {
        per_page: 100,
        page: 1,
      }
    }).callbacks(() => { }).connect(props.domains.settings);

    this.export_data = RESTExecutor.post().config({
      label: 'export'
  }).callbacks((success) => {
      this.setState({ selected_ids: [] })
      // console.log("download url",success)
      window.open(success.result.url, '_blank');

  }, (error) => {
      showErrorInNotification(error)
  }).connect(props.domains.settings);


    this.delay_search=new NetworkDelaySearch();


  };


  stateUpdater = ({
    stateKey,
    valueKey,
    value,
    appendObj = {},
    callback
  }) => {
    let newData = this.state[stateKey];
    this.has_changed = true;
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }


  render() {
    let list_table_resp = this.list_tables.response();
    let list_table_data = list_table_resp.result || {};
    let rowsData = list_table_data.rows || [];
    let rowsMeta = list_table_resp.meta || {};

   
    const { filter_query,selected_ids } = this.state;

    return (
      <div>
        <BasicHeader no_back title="Tables"
                    menu_items={setting_quick_menu}
                    right={[
                        <Link to={`/settings/tables/add`}>
                        <TransparentButton
                            label="Add New"
                            className='cta-primary'
                            hint="Add New Table"
                        /></Link>,
                        <TransparentButton
                        label="Export"
                        hint="Export Selected Groups"
                        disabled={selected_ids.length == 0}
                        onClick={() => {
                            this.export_data.execute({
                                tables:selected_ids
                            });
                        }}
            
                    />
                    ]}

                />
                <div className='filter-card'>
                    <div className='filter-card-top' style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flexWrap: 'nowrap',

                    }}>
 <Input.Search
                  placeholder="Search For"
                  style={{
                  }}
                  autoFocus
                  allowClear
                  value={filter_query.query}
                  onChange={(e) => {
                    this.stateUpdater({ 
                      stateKey: 'filter_query', valueKey: 'query', value: e.target.value,
                      callback:()=>{

                        this.delay_search.onSearch(()=>{
                          this.props.history.push({
                            search:queryString.stringify({...this.state.filter_query,per_page:100,page:1})
                          })
                        })
                        
                      }
                     })
                  }}
                   /> 
                    </div>
                    </div>
      <ErrorWrapper
        error={list_table_resp}
        onReload={() => {
          this.list_tables.execute()
        }}>
        <div className='default-card' style={{ padding: 0 }}>
         

          <Table
          scroll={{x:true}}
            // rowClassName='hand-cursor'
            className='main-table'
            loading={list_table_resp.fetching}
            rowSelection={{
              onChange: (selected_ids) => {
                  this.setState({ selected_ids })
              },
              selectedRowKeys: selected_ids
          }}
            size='small'

            pagination={{
              simple: false,
                    position:'bottom',
              onChange: (current, size) => {
                this.props.history.push({
                  search:queryString.stringify({...this.state.filter_query,per_page:size,page:current})
                })
              },
              defaultCurrent: 1,
              current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
              pageSize: (rowsMeta && rowsMeta.requested_count),
              total: (rowsMeta && rowsMeta.total_count),
              showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
            }}
            rowKey={(record) => record.id}
            columns={[
              { title: "Table Name", dataIndex: 'name', key: 'name',className:'bold-cell' },
              {
                title: "Allowed Methods", dataIndex: 'allowed_methods', key: 'allowed_methods', render: (list_methods = []) => {
                  return <span>{
                    list_methods.map((item) => {
                      return <Tag color="#108ee9">{item}</Tag>
                    })
                  }</span>

                }
              },
              {
                title: "", dataIndex: "id", key: 'id', render: (id, data) => {
                  return <Link to={`/settings/tables/${id}/edit`}><Button type='link' >Edit</Button>
                  </Link> 
                }
              }
            ]}
            dataSource={rowsData}
          />

        </div>
      </ErrorWrapper>
      </div>
    );

  }

  componentDidMount() {
    // this.list_tables.execute();
    overrideHeaderTitle("Tables");
    overrideHeaderBack(null);
    let new_filter_query={};
    if(this.props.location&&this.props.location.search){
    const parsed = queryString.parse(this.props.location.search);
    new_filter_query=parsed;
    }
    this.setState({
    filter_query:{
        per_page:100,
        page:1,
        ...new_filter_query
    }
    },()=>{
    this.list_tables.config({
        params: {
        ...this.state.filter_query
        }
    }).execute()
    })
  }
  componentWillReceiveProps (nextProps) {
    
    let new_filter_query={};
    if((this.props.location.search!==nextProps.location.search)){
      const parsed = queryString.parse(nextProps.location.search);
      new_filter_query=parsed;
      this.setState({
        filter_query:{
          per_page:100,
          page:1,
          ...new_filter_query
        },
        selected_ids:[]
      },()=>{
        this.list_tables.config({
          params: {
            ...this.state.filter_query
          }
        }).execute()
      })
    }else{
    //   this.list_logs.execute()
    }

    
  }
}

export default withDomains(TableList, "settings");
